import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6dae8fe4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-preview" }
const _hoisted_2 = { class: "image-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"chat\" data-v-6dae8fe4><div class=\"chat-name loading-skeleton w-50\" data-v-6dae8fe4>_</div><div class=\"message-wrapper\" data-v-6dae8fe4><div class=\"message loading-skeleton w-80\" data-v-6dae8fe4>_</div></div></div><div class=\"information\" data-v-6dae8fe4><div class=\"date loading-skeleton\" data-v-6dae8fe4>_______</div></div>", 2)

import Icon from "@/components/icons/Icon/Icon.vue";
import { IconType } from "@/types/icons";

export default /*#__PURE__*/_defineComponent({
  __name: 'ChatPreviewLoading',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Icon, {
        icon: _unref(IconType).DEFAULT_SINGLE_GRAY,
        alt: "user"
      }, null, 8, ["icon"])
    ]),
    _hoisted_3
  ]))
}
}

})